import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Icons from '../../../../common/widgets/Icons';
import { MenuListItem } from '../../../../common/widgets/MenuListItem';
import { config } from '../../config';
import { AccountInfoContext } from '../../contexts/AccountInfoContext';
import { resources } from '../../resources/resources';

export const Menu = () => {
  const { t: translate } = useTranslation();
  const { accountInfo } = useContext(AccountInfoContext);

  return (
    <div className="action-panel">
      <div className="action-panel-content m-nav">
        <ul>
          <MenuListItem
            text={translate(resources.menu.home)}
            icon={<Icons.MHome />}
            linkPath="/"
            exactMatch
          />
          <MenuListItem
            text={translate(resources.menu.products.title)}
            icon={<Icons.MProducts />}
            exactMatch
            childrenItems={[
              {
                text: translate(resources.menu.products.all),
                linkPath: '/products',
                exactMatch: true,
                controlClassName: 'nav-expanded-item',
              },
              {
                text: translate(resources.menu.products.addProduct),
                linkPath: '/products/add',
                exactMatch: true,
                controlClassName: 'nav-expanded-item',
              },
              {
                text: translate(resources.menu.products.addCodes),
                linkPath: '/products/codes',
                exactMatch: true,
                controlClassName: 'nav-expanded-item',
              },
            ]}
          />
          <MenuListItem
            text={translate(resources.menu.notifications)}
            icon={
              accountInfo.notificationsCount > 0 ? (
                <Icons.MNotificationsUnread />
              ) : (
                <Icons.MNotifications />
              )
            }
            linkPath="/notifications"
            exactMatch={false}
          />
          {config.showAnalytics && accountInfo.usesAnalytics && (
            <MenuListItem
              text={translate(resources.menu.analytics)}
              icon={<Icons.MAnalytics />}
              linkPath="/analytics"
              exactMatch
            />
          )}
          <MenuListItem
            text={translate(resources.menu.members)}
            icon={<Icons.MMembers />}
            linkPath="/accounts"
            exactMatch
          />
          <MenuListItem
            text={translate(resources.menu.marketing)}
            icon={<Icons.MMarketing />}
            linkPath="/marketing"
            exactMatch
          />
        </ul>
      </div>
    </div>
  );
};
